export default [{
  path: '/grupo-usuario',
  component: {
    resource: 'grupo',
    action: 'read',
    name: 'grupoUsuarioBase',
    template: '<router-view />',
    meta: {
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'gruposusuarios',
    component: () => import('@/app-modulo/comuns/grupo-usuario/GrupoUsuarioView.vue'),
    meta: {
      resource: 'grupo',
      action: 'read',
      navActiveLink: 'gruposusuarios',
      pageTitle: 'Permissões de Grupos de Usuários',
      breadcrumb: [
        {
          text: 'Grupos de usuários',
          to: { name: 'gruposusuarios' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'add',
    name: 'add-grupousuario',
    component: () => import('@/app-modulo/comuns/grupo-usuario/shared/components/cadastro/GrupoUsuario.vue'),
    meta: {
      resource: 'grupo',
      action: 'create',
      navActiveLink: 'gruposusuarios',
      pageTitle: 'Permissões de Grupos de Usuários',
      breadcrumb: [
        {
          text: 'Grupos de usuários',
          to: { name: 'gruposusuarios' },
        },
        {
          text: 'Adicionar',
          to: { name: 'add-grupousuario' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-grupousuario',
    component: () => import('@/app-modulo/comuns/grupo-usuario/shared/components/cadastro/GrupoUsuario.vue'),
    meta: {
      resource: 'grupo',
      action: 'update',
      navActiveLink: 'gruposusuarios',
      pageTitle: 'Permissões de Grupos de Usuários',
      breadcrumb: [
        {
          text: 'Grupos de usuários',
          to: { name: 'gruposusuarios' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-grupousuario' },
          active: true,
        },
      ],
    },
  }],
}]
